/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Header/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CloseAction from './CloseAction/index'
import MoveAction from './MoveAction/index'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Header({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/Header"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let appointmentOverlayValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_overlay',
format: fromHelpers.getTitle,
})
  return (<React.Fragment
>
<div
  data-testid="Header.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z2wmEtq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="appointment_overlay"
 format="helpers.js getTitle"
 text={appointmentOverlayValueData}
/>
<div
  data-testid="Header.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="orange"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Beta"
/>
)}
</TysiaTag>
</div>
</div>
<div
  data-testid="Header.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Z2wmEtq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<MoveAction
  viewPath={`${viewPath}/MoveAction`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
{children}
</React.Fragment>)
}